<template>
  <div id="APP">
      <router-view></router-view>
      <div class="kefu">
        <van-icon name="chat-o" />
      </div>
      <div class="kf" v-if="showKf" @click="toKefu">
        <img src="./assets/images/online.png" >
    </div>

  </div>
</template>
<script type="text/javascript">
  import {mapState} from 'vuex';
  import ChatSDK from '@livechat/chat-sdk';
  import * as echarts from "echarts"; // 检查导入方式
  export default {
    data() {
      return {
        showKf:false,
      }
    },
    created() {
      const allowedDomains = ['defehi.com', 'usdefv.com','web32025.top'];
      const currentDomain = window.location.hostname;

      if (allowedDomains.includes(currentDomain)) {
        console.log('当前域名是允许的');
        this.showKf = true
      } else {
        this.showKf = false

        console.log('当前域名不在允许列表中');
      }

      // 你可以使用其他可用事件监听
      window.LiveChatWidget.on('ready', () => {
        LiveChatWidget.call("set_session_variables", {
          UserId:  sessionStorage.getItem("userToken"),
        });
      });
    },
    methods: {
      toKefu(){
        window.open('https://direct.lc.chat/17356023/', '_blank');
      },
    }
  }
</script>
<style  type="text/css">
.kf{
  z-index: 100;
  float: right;
  position: absolute;
  bottom: 50px;
  right: 20px;
}
.kf img{
  width: 40px;
  height: 40px;
}


  * {
    margin: 0;
    padding: 0;
    font-style: normal;
    box-sizing: border-box;
    font-size: 100%;
  }
  body {
    overscroll-behavior: none; /* 禁止滚动到边界的回弹效果 */
    overflow: hidden; /* 禁止滚动 */
  }
  ul,
  li,
  ol {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: #fff;
  }

  html,
  body,
  #APP {
    width: 100%;
    height: 100%;
    font-size: 14px;
    color:#333;
  }

  input,
  select,
  option,
  button,
  textarea {
    font-size: 100%;
    vertical-align: middle;
    outline: 0 none;
    border-radius: 0px;
    border: none;
    transition: all ease 0.36s;
    background: none;
  }

  input::-webkit-input-placeholder {
    color: #999;
  }

  input::-ms-input-placeholder {
    color: #999;
  }

  input::-moz-input-placeholder {
    color: #999;
  }

  .mint-swipe {
    height: 200px !important;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .mt-progress {
    height: 10px !important;
    line-height: 10px !important;
  }

  .wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /*头部样式*/
  header {
    position: relative;
    height: 50px;
    line-height: 50px;
    color: #fff;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(to right, #3476fe, #34c7fe);

    h2 {
      position: absolute;
      height: 100%;
      left:50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      span{
        text-align: center;
      }
      img {
        height: 25px;
      }
    }
  }

  .main{
    flex:1;
    background: #fff;
    overflow-y:auto;
  }

  .no-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;
    padding-top: 50px;

    p {
      color: rgba(4, 15, 66, 0.3);
      margin-top: 5px;
    }
  }

  .tableHeadercell,
  .tableCell {
    text-align: center !important;
  }

  .mint-msgbox-content{
    max-height: 400px;
    overflow: auto;
  }
  

  @media screen and (min-width: 640px) {
    .wrap {
      max-width: 500px;
      margin: 0 auto;
    }
    ::-webkit-scrollbar {/*滚动条整体样式*/
      width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.5);
      cursor: pointer;
    }
    ::-webkit-scrollbar-track {/*滚动条里面轨道*/
      border-radius: 4px;
      background: #fff;
    }
  }
</style>